import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const setInvestmentValuesAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (event.type !== "INVESTMENT_INITIALIZED")
    throw new Error(`Invalid event type ${event.type}`);

  return {
    investmentValues: event.investmentValues,
    sourceInvestmentValues: {},
    bookingValues: {
      ...context.bookingValues,
      accountCurrency:
        event.accountCurrency ?? context.bookingValues.accountCurrency,
      entryQuote: event.entryQuote ?? context.bookingValues.entryQuote,
    },
  };
};
